import React, { useState } from "react";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import "./PageHeader.scss";
import { FavoritesIcon } from "../../../assets/images/svg";

const PageHeader = ({ pageTitle = "", learnMore, isFavorite, isFavoriteLoading, toggleFavorite, withFavorite }) => {
  const handleClick = e => {
    e.preventDefault();
    if (!isFavoriteLoading) toggleFavorite(!isFavorite);
  };
  const [isMouseEnter, setIsMouseEnter] = useState(false);

  // TODO: delete when react-tooltip new version will be released
  let hideOrShow = text => {
    if (!isMouseEnter) return "";
    else return text;
  };

  const dataTip = () => {
    if (isFavoriteLoading) {
      return "";
    } else if (isFavorite) {
      return hideOrShow("Remove from Favorites");
    } else {
      return hideOrShow("Add to Favorites");
    }
  };
  let id = pageTitle.toLowerCase() + "-tooltip";
  return (
    <div className="page-header-nav">
      <p className="page-header-nav__title">{pageTitle}</p>

      {learnMore !== undefined && <div className="page-header-nav__learnMore">{learnMore}</div>}
      {withFavorite && (
        <button
          data-for={id}
          onMouseEnter={() => setIsMouseEnter(true)}
          onMouseLeave={() => setIsMouseEnter(false)}
          className={`page-header-nav__favorites ${isFavorite ? "page-header-nav__favorites--selected" : ""}
        ${isFavoriteLoading ? "page-header-nav__favorites--disabled" : ""}`}
          onClick={handleClick}
          // disabled={isFavoriteLoading}
          data-tip={dataTip()}
        >
          <FavoritesIcon width="20" height="20" viewBox="0 0 18 18" className="icon" />
          <ReactTooltip id={id} place="bottom" effect="solid" textColor="white" className={"tooltip"} getContent={dataTip} />
        </button>
      )}
    </div>
  );
};

PageHeader.propTypes = {
  pageTitle: PropTypes.string,
  learnMore: PropTypes.any,
  isFavorite: PropTypes.bool,
  isFavoriteLoading: PropTypes.bool,
  toggleFavorite: PropTypes.func,
  withFavorite: PropTypes.bool
};
export default PageHeader;
